import { Buff } from "../../../buffs/buff"
import { BuffOnHitConfig } from "../ai-types"
import { Enemy } from "../enemy"

export const onHitBehaviours = {
    buff(entity: Enemy, config: BuffOnHitConfig, damage: number, isDot: boolean) {
        Buff.apply(config.buff, entity, entity, config.stacks, config.duration)
    }
}